import React, {useEffect, useState} from "react";
import { presetDarkPalettes, presetPalettes } from '@ant-design/colors';

import { ThemeMode, ThemeDirection} from "../config";
import { alpha, useTheme } from '@mui/material/styles';
import { Box, CardMedia, FormControlLabel, Radio, RadioGroup, Slide, Stack } from '@mui/material';
import useConfig from "../hooks/useConfig";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";

import HeaderPage from "../sections/landing/Header";
import AnimateButton from "../Components/@extended/AnimateButton";
import FeatureBlock from "../sections/landing/FeatureBlock";
import ServicesBlock from "../sections/landing/ServicesBlock";
import TestimonialBlock from "../sections/landing/TestimonialBlock";
import FooterBlock from "../layout/CommonLayout/FooterBlock"
import PricingXeroSubscription from "../pages/pricing/pricing-xero-subscription";
import Roadmap from "../sections/landing/Roadmap";

const dashImage = require.context('../assets/landing', true);

const Landing = (props) => {
    const theme = useTheme();
    const { mode, presetColor, onChangePresetColor } = useConfig();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        console.log(theme)
        const listenToScroll = () => {
          let heightToHideFrom = 250;
          const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

          if (winScroll > heightToHideFrom) {
            setVisible(true);
          } else {
            visible && setVisible(false);
          }
        };

        window.addEventListener('scroll', listenToScroll);
        return () => window.removeEventListener('scroll', listenToScroll);
      }, [visible]);
      const colors = mode === ThemeMode.DARK ? presetDarkPalettes : presetPalettes;
      const { blue } = colors;
      const colorOptions = [
        {
          id: 'theme1',
          primary: mode === ThemeMode.DARK ? '#305bdd' : '#3366FF'
        },
        {
          id: 'theme2',
          primary: mode === ThemeMode.DARK ? '#655ac8' : '#7265E6'
        },
        {
          id: 'theme3',
          primary: mode === ThemeMode.DARK ? '#0a7d3e' : '#068e44'
        },
        {
          id: 'theme4',
          primary: mode === ThemeMode.DARK ? '#5d7dcb' : '#3c64d0'
        },
        {
          id: 'default',
          primary: blue[5]
        },
        {
          id: 'theme5',
          primary: mode === ThemeMode.DARK ? '#d26415' : '#f27013'
        },
        {
          id: 'theme6',
          primary: mode === ThemeMode.DARK ? '#288d99' : '#2aa1af'
        },
        {
          id: 'theme7',
          primary: mode === ThemeMode.DARK ? '#05934c' : '#00a854'
        },
        {
          id: 'theme8',
          primary: mode === ThemeMode.DARK ? '#058478' : '#009688'
        }
      ];
    const handlePresetColorChange = (event) => {
      onChangePresetColor(event.target.value);
    };
    return (
        <>
      {/*       <Navbar style={{background:"grey.0"}}>*/}
      {/*  <Container>*/}
      {/*    <Navbar.Brand href="/" style={{color:"white"}}>Ikigai</Navbar.Brand>*/}
      {/*      <Nav className="justify-content-end">*/}
      {/*        {props.LoginButton}*/}
      {/*      </Nav>*/}


      {/*  </Container>*/}
      {/*</Navbar>*/}
            <Box
        sx={{
          position: 'relative',
          bgcolor: theme.palette.mode === ThemeMode.DARK ? 'grey.0' : 'grey.800',
          overflow: 'hidden',
          minHeight: '100vh',
          '&>*': {
            position: 'relative',
            zIndex: 5
          },
          '&:before': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            zIndex: 2,
            background:
              theme.direction === ThemeDirection.RTL
                ? {
                    xs: 'linear-gradient(-360.36deg, rgb(0, 0, 0) 14.79%, rgba(67, 67, 67, 0.28) 64.86%)',
                    md: 'linear-gradient(-329.36deg, rgb(0, 0, 0) 1.79%, rgba(67, 67, 67, 0.28) 64.86%)',
                    xl: 'linear-gradient(-329.36deg, rgb(0, 0, 0) 1.79%, rgba(67, 67, 67, 0.28) 64.86%)'
                  }
                : 'linear-gradient(329.36deg, rgb(0, 0, 0) 14.79%, rgba(67, 67, 67, 0.28) 64.86%)'
          }
        }}
      >
        <CardMedia
          component="img"
          image={dashImage(`./landingpage-theme1.jpg`)}
          sx={{
            position: 'absolute',
            width: { md: '78%', lg: '70%', xl: '65%' },
            right: { md: '-14%', lg: '-4%', xl: '-2%' },
            top: { md: '16%', lg: '12%', xl: '8%' },
            zIndex: 1,
            display: { xs: 'none', md: 'block' }
          }}
        />
                <HeaderPage />
      </Box>
            <FeatureBlock />
            <ServicesBlock />
            <PricingXeroSubscription/>
            <TestimonialBlock />
            <Roadmap />
            {/*<FooterBlock />*/}
        </>
    )

}

export default Landing;